module.exports = "<div *ngIf=\"message\" [ngClass]=\"message.cssClass\">\n  Votre e-mail ou mot de passe incorrect. Merci de vérifier votre saisie.\n</div>"